export const APP_KEY = "5d8717907c9fad8c15678c7d286c0237";
export const STORY_URL = "http://demo.goemotify.com/post1.html";
export const STORY_ID = "90801";
